import { object } from "framer-motion/client";
import BaseListPresenter from "../../base/BaseListPresenter";
import saveAs from "../../saveAs";

class DashboardAppPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  async findJobs() {
    const collection = "job_posting";

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const today = new Date();
      const utcMidnight = new Date(today.getTime() + 8 * 60 * 60 * 1000);
      utcMidnight.setUTCHours(0, 0, 0, 0);

      const todayISO = utcMidnight.toISOString();

      const query = {
        where: { deadline: { $ne: todayISO } },
      };

      const objects = await this.findObjectUseCase.execute(collection, query);

      this.view.setState({ countJob: objects.length });
    } catch (error) {
      this.view.showError(error.message || error);
    } finally {
      this.hideProgress();
    }
  }

  async findObjects() {
    const collection1 = "online_applicants";
    const collection2 = "walkIn_applicants";

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const [objects1, objects2] = await Promise.all([
        this.findObjectUseCase.execute(collection1),
        this.findObjectUseCase.execute(collection2),
      ]);

      const counts = {
        onlineApplicants: objects1.length,
        walkInApplicants: objects2.length,
      };

      const totalCount = counts.onlineApplicants + counts.walkInApplicants;

      this.view.setState({ totalCount });
    } catch (error) {
      console.error("Error in findObjects", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }
}

export default DashboardAppPagePresenter;
